import cx from 'classnames'
import Icon from 'components/shared/Icon'
import IconButton from '@material-ui/core/IconButton'
import React from 'react'
import { CURRENT_AWARENESS } from 'constants/controllers'

const LeftDrawerWrapper = ({ pageView, isLargeDesktop, windowHeight, headerHeight, pageToggleLeft, controller, children, deviceType }) => (
  <div
    className={cx(
      { dn: controller === CURRENT_AWARENESS && isLargeDesktop },
      'sticky-l fixed-m absolute left0 top0 side-width shadow-black-1 shadow-none-l z10 bg-ghost-grey max-w-100 transition-all',
      { 'x--100 x-0-l': pageView !== 'left' }
    )}
    style={{
      height: `${windowHeight - headerHeight}px`,
      top: deviceType.isMobile ? headerHeight : null
    }}
  >
    <div className='relative h-100'>
      <button
        className='dn-l bg-grey hover-bg-dim-grey db absolute top-50 right0 shadow-none black br2 br--right pa4 x-100 pointer o-70'
        onClick={pageToggleLeft}
      >
        <Icon
          name={pageView === 'left' ? 'icon-chevron-double-left' : 'icon-chevron-double-right'}
          className={cx('w7 vm')}
        />
      </button>
      <div className='relative h-100 overflow-y-auto'>
        <IconButton
          classes={{ root: 'dn-l bg-transparent db absolute top5 right5 shadow-none black hover-cadet-blue mr2' }}
          size='small'
          onClick={pageToggleLeft}
        >
          <Icon className='w7' name='icon-close' />
        </IconButton>
        {children}
      </div>
    </div>
  </div>
)

export default LeftDrawerWrapper
